module.exports = __webpack_public_path__ + "img/icon-renxing.e8ae70f4.png";